// Mock data for Urban Hunter website

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about-us" },
  { name: "Services", path: "/services" },
  { name: "Contact Us", path: "/contact-us" },
  { name: "Blogs", path: "https://blogs.urbanhunter.in/" },
];

export const heroData = {
  rotatingHeadlines: [
    "Stop Wasting Ad Spend. Start Scaling Profitably.",
    "From Ad Spend to Actual Profit, We Fix Your Growth Engine",
    "Your Growth Partner, Not Just Another Agency",
    "We Turn Underperforming Brands Into Market Leaders",
  ],
  description:
    "Are you winning the marketplace, or just participating in it? We combine marketplace intelligence, Full funnel analytics, and precision media to drive sustainable dominance.",
  subDescription: "Ready to scale with precision? Let's talk.",
  ctaText: "Get a Free Growth Audit",
  ctaLink: "/free-audit",
  heroImage: "/homepage2.png",
};

export const aboutSectionData = {
  title: "Your Growth Partner, Not Just Another Agency",
  description:
    "Urban Hunter is an authorized Amazon Ads partner, trusted by brands across 20+ global marketplaces to manage and scale high performance advertising ecosystems. We don't just run campaigns we architect data driven growth systems designed for profitability, stability, and long term brand dominance.",
  subDescription:
    "We work best with brands that are serious about scaling, value strategy over shortcuts, and want a long term growth partner.",
  linkText: "More about our unique approach",
  linkUrl: "/about-us",
};

export const whyChooseUsData = {
  title: "Why High Growth Brands Choose Urban Hunter",
  description:
    "At Urban Hunter, every decision is backed by data not assumptions. We focus on what truly matters: profitability over vanity metrics, sustainable scaling over short term spikes, and systems over hacks.",
  subtitle: "We are built for brands ready to dominate:",
  features: [
    {
      icon: "BarChart3",
      title: "Authorized Amazon Ads Partner",
      description:
        "As an authorized Amazon Ads partner with proven experience across global markets (US, UK, India, Germany, France, Spain, Russia, Japan, Italy), we bring deep expertise in managing high spend accounts and understanding competitive marketplace dynamics.",
    },
    {
      icon: "Target",
      title: "Intelligence Led Scaling",
      description:
        "We leverage advanced tools including Helium 10, Jungle Scout, Amazon Marketing Cloud, and Drona to uncover opportunities, optimize performance, and build predictable, scalable growth models.",
    },
    {
      icon: "TrendingUp",
      title: "Founder Led Strategy & Execution",
      description:
        "Every account benefits from founder level attention. Our performance first mindset means we prioritize building systems that scale sustainably with strategic depth that goes beyond basic campaign management.",
    },
  ],
};

export const servicesData = [
  {
    id: "google-ads",
    title: "Google Ads Management",
    shortDescription:
      "Turn Search Intent Into Real Revenue. Precision built campaigns designed to capture high intent demand and convert it into measurable business growth.",
    fullDescription:
      "At Urban Hunter, we build Google Ads systems that are designed to capture high intent demand and convert it into measurable business growth. Most brands don't struggle with traffic they struggle with converting it profitably. Our focus isn't just on running campaigns, but on creating a structured acquisition engine that consistently delivers results.",
    logo: "/platforms/google.png",
    features: [
      "Search campaigns aligned with real user intent",
      "Shopping campaigns with advanced feed optimization",
      "Display & YouTube for full funnel coverage",
      "Account architecture with precision match types",
      "Continuous creative and bidding strategy testing",
      "Conversion tracking and end to end analytics",
      "Scaling only when campaigns are proven profitable",
    ],
    sections: [
      {
        icon: "🧠",
        title: "Our Approach Foundation First",
        description:
          "We believe scaling Google Ads is not about increasing budgets blindly, but about building a strong foundation first.",
        points: [
          { title: "Refine Existing Campaigns", desc: "Align keywords, ad copies, and targeting to match real user intent." },
          { title: "Optimize Structure", desc: "Ensure right match types, negative keywords, and audience signals for maximum relevance." },
          { title: "Strategic Budget Allocation", desc: "Direct budgets toward high performing areas while eliminating waste." },
          { title: "Expand Into Multiple Formats", desc: "Scale into Search, Shopping, Display, and YouTube once performance is proven." },
        ],
      },
      {
        icon: "⚙️",
        title: "Execution That Drives Performance",
        description: "A strong campaign is built on structure. We focus deeply on account architecture and optimization.",
        points: [
          { title: "Account Architecture", desc: "Right match types, negative keywords, and audience signals in place to maximize relevance." },
          { title: "Shopping Campaign Dominance", desc: "Detailed feed optimization to help your products dominate visibility on search results." },
          { title: "Conversion Tracking & Analytics", desc: "Complete clarity on performance with proper configuration of all tracking systems." },
          { title: "Data Driven Decisions", desc: "Every decision backed by data. Continuous testing of creatives, audiences, and bidding strategies." },
        ],
      },
      {
        icon: "📈",
        title: "Real Impact",
        description: "Proven results across diverse industries and account sizes.",
        points: [
          { title: "B2B Healthcare Marketplace", desc: "Scaled campaigns nearly 3x within 3 months while reducing acquisition costs through structured Shopping strategy." },
          { title: "Logistics Delivery Brand", desc: "Significantly lowered customer acquisition costs by restructuring campaigns and improving quality scores." },
          { title: "Focus on Profitability", desc: "Every engagement prioritizes real business outcomes over vanity metrics." },
        ],
      },
    ],
    link: "/services/google-ads",
  },
  {
    id: "amazon-ads",
    title: "Amazon Ads & Marketplace Growth",
    shortDescription:
      "Authorized Amazon Ads partner trusted by brands across 20+ global marketplaces to manage and scale high performance advertising ecosystems.",
    fullDescription:
      "Urban Hunter is an authorized Amazon Ads partner, trusted by brands across 20+ global marketplaces to manage and scale high performance advertising ecosystems.\n\nWe don't just run campaigns we architect data driven growth systems designed for profitability, stability, and long term brand dominance.",
    logo: "/platforms/amazon_ads.png",
    features: [
      "Sponsored Products, Brands & Display Precision built campaign structures",
      "Conversion focused listings & keyword rich SEO for US markets",
      "Premium A+ Content, infographics, brand stores & storytelling",
      "Compliance & account health proactive policy & issue resolution",
      "Helium 10, Jungle Scout & Amazon Marketing Cloud / Amazon Pi",
      "Drona powered insights for predictable, scalable growth models",
      "Profitability over vanity metrics systems over hacks",
    ],
    sections: [
      {
        icon: "💎",
        title: "Full Funnel Amazon Growth Infrastructure",
        description:
          "We deliver an integrated approach that aligns advertising, content, and conversion into one seamless growth engine.",
        points: [
          { title: "Advanced Amazon Advertising", desc: "Precision built campaign structures across Sponsored Products, Brands, and Display designed to dominate search, capture demand, and scale efficiently." },
          { title: "Conversion Focused Listings & SEO", desc: "We craft keyword rich, high converting listings that not only rank but consistently convert in competitive US markets." },
          { title: "Premium Creative & Brand Experience", desc: "From A+ Content and infographics to brand stores and storytelling we design experiences that elevate perception and increase conversion rates." },
          { title: "Compliance & Account Stability", desc: "Proactive support for account health, policy compliance, and issue resolution ensuring uninterrupted growth at scale." },
        ],
      },
      {
        icon: "🧠",
        title: "Intelligence Led Scaling",
        description: "At Urban Hunter, every decision is backed by data not assumptions. We leverage advanced tools to uncover opportunities, optimize performance, and build predictable, scalable growth models.",
        points: [
          { title: "Helium 10", desc: "Deep keyword research, listing optimization and competitor analysis." },
          { title: "Jungle Scout", desc: "Market intelligence and product opportunity identification." },
          { title: "Amazon Marketing Cloud / Amazon Pi", desc: "Advanced attribution and audience insights across the funnel." },
          { title: "Drona", desc: "Proprietary tooling for performance tracking and scaling decisions." },
        ],
      },
      {
        icon: "⚙️",
        title: "Our Philosophy Data. Precision. Scale.",
        description: "We focus on what truly matters:",
        points: [
          { title: "Profitability over vanity metrics", desc: "Every decision is tied to real business outcomes, not surface level numbers." },
          { title: "Sustainable scaling over short term spikes", desc: "We build growth systems that compound over time." },
          { title: "Systems over hacks", desc: "Repeatable, data driven processes that work at any scale." },
        ],
      },
    ],
    link: "/services/amazon-ads",
  },
  {
    id: "performance-engine",
    title: "Performance Engine",
    shortDescription:
      "Precision built Google Ads and Meta Ads campaigns designed to capture high intent demand and convert it into measurable business growth.",
    fullDescription:
      "At Urban Hunter, we build performance advertising systems designed to capture high intent demand and convert it into measurable business growth. Our focus isn't just on running campaigns it's on creating a structured acquisition engine that consistently delivers results.\n\nWe believe scaling is not about increasing budgets blindly, but about building a strong foundation first. We start by refining your existing campaigns aligning keywords, ad copies, and targeting to match real user intent. Once the structure is optimized, we strategically allocate budgets toward high performing areas while eliminating waste.",
    logo: "/services_ass/Performance_Marketing.png",
    features: [
      "Google Ads — Search, Shopping, Display, and YouTube",
      "Meta Ads — Facebook & Instagram full funnel campaigns",
      "Account architecture with right match types & negative keywords",
      "Continuous creative and audience signal testing",
      "Conversion tracking and analytics configuration",
      "Feed optimization for Shopping campaign dominance",
      "Scaling only begins when campaigns are proven profitable",
    ],
    link: "/services/performance-engine",
  },
  {
    id: "marketplace-expansion",
    title: "Marketplace Expansion",
    shortDescription:
      "Full funnel Amazon growth infrastructure and India marketplace scaling across Flipkart, Meesho, and Nykaa.",
    fullDescription:
      "Urban Hunter helps brands unlock growth across high impact global and Indian marketplaces combining strategy, optimization, and performance marketing to drive consistent sales and visibility. From catalog to campaigns, we build systems that scale.\n\nFor Amazon US, we architect Precision built campaign structures designed to dominate search and scale efficiently. For Indian marketplaces (Flipkart, Meesho, Nykaa), we help brands achieve visibility and consistency at volume.",
    features: [
      "Amazon Ads — Sponsored Products, Brands & Display (US & India)",
      "Conversion focused listings & keyword rich SEO",
      "Premium A+ Content, infographics & brand stores",
      "Flipkart — Ads management, listing optimization & conversion scaling",
      "Meesho — Product setup, pricing strategy & high volume sales optimization",
      "Nykaa — Beauty category expertise & premium brand positioning",
    ],
    sections: [
      {
        icon: "🛍️",
        title: "Flipkart Growth",
        description: "Dominate one of India's largest eCommerce ecosystems.",
        points: [
          { title: "Listing Optimization & Keyword Strategy", desc: "Comprehensive keyword research and listing optimization for maximum visibility." },
          { title: "Flipkart Ads Management & Scaling", desc: "Strategic campaign management to drive consistent sales growth." },
          { title: "Catalog Structuring", desc: "Organized product structure for better visibility and searchability." },
          { title: "Sales & Conversion Optimization", desc: "data driven strategies to improve conversion rates and average order value." },
        ],
      },
      {
        icon: "👗",
        title: "Meesho Expansion",
        description: "Perfect for scaling volume driven, price sensitive categories.",
        points: [
          { title: "Product Listing & Catalog Setup", desc: "Complete onboarding and catalog structuring for high visibility." },
          { title: "Pricing & Competitiveness Strategy", desc: "Competitive pricing analysis and strategy for market dominance." },
          { title: "High Volume Sales Optimization", desc: "Systems to drive consistent, scalable sales volume." },
          { title: "Order & Performance Management", desc: "full cycle management from listing to fulfillment and optimization." },
        ],
      },
      {
        icon: "💄",
        title: "Nykaa Brand Growth",
        description: "Built for brands targeting premium, beauty focused audiences.",
        points: [
          { title: "Beauty & Personal Care Expertise", desc: "Deep category knowledge and premium positioning strategies." },
          { title: "Premium Listing & Brand Positioning", desc: "Craft high converting listings that elevate brand perception." },
          { title: "Nykaa Ads & Visibility Optimization", desc: "Strategic advertising to maximize discoverability and reach." },
          { title: "Conversion focused Content Strategy", desc: "Content that resonates with premium beauty buyers and drives conversions." },
        ],
      },
      {
        icon: "📊",
        title: "Our Approach — Visibility → Conversion → Scale",
        description:
          "We don't just list products—we optimize every step of the customer journey to maximize performance across platforms.",
        points: [
          { title: "Marketplace Onboarding & Setup", desc: "Complete setup from scratch with best practices." },
          { title: "Listing Creation & SEO", desc: "keyword rich, high converting listings optimized for discovery." },
          { title: "Ad Campaign Management", desc: "Strategic promotional campaigns for continuous growth." },
          { title: "Inventory & Pricing Strategy", desc: "Dynamic pricing and inventory management for optimal margins." },
          { title: "Performance Tracking & Optimization", desc: "Continuous monitoring and optimization driven by data." },
        ],
      },
    ],
    link: "/services/marketplace-expansion",
  },
  {
    id: "quick-commerce",
    title: "Quick Commerce Acceleration",
    shortDescription:
      "Win the 10 minute delivery economy across Blinkit, Zepto, Swiggy Instamart, and Amazon Now.",
    fullDescription:
      "Quick commerce is not just about being listed it's about being visible, available, and chosen instantly. At Urban Hunter, we help brands scale across platforms like Blinkit, Zepto, Swiggy Instamart, and Amazon Now by building systems that drive visibility and conversions in high speed buying environments.\n\nWe focus on what actually drives sales in quick commerce placement, availability, and demand. From optimizing your product listings and pricing strategy to improving discoverability within platform algorithms, we ensure your brand stands out when customers are ready to buy.",
    logo: "/platforms/zepto.png",
    features: [
      "Blinkit visibility & placement optimization",
      "Zepto catalog readiness & demand scaling",
      "Swiggy Instamart platform strategy & promotions",
      "Amazon Now (India) growth management",
      "Product listing & pricing strategy optimization",
      "Platform algorithm discoverability improvement",
      "Strategic promotions and data backed scaling",
    ],
    sections: [
      {
        icon: "🧠",
        title: "Our Approach — Placement, Availability & Demand",
        description:
          "We focus on what actually drives sales in quick commerce placement, availability, and demand.",
        points: [
          { title: "Product Listing Optimization", desc: "Optimize your product listings for quick commerce platform standards." },
          { title: "Pricing Strategy", desc: "Competitive pricing that drives volume without eroding margins." },
          { title: "Discoverability Improvement", desc: "Improve your brand's visibility within platform algorithms and search results." },
          { title: "Strategic Scaling", desc: "As performance improves, scale visibility through strategic promotions and data backed decisions." },
        ],
      },
      {
        icon: "📈",
        title: "Where We Add Value",
        description:
          "We work closely with your brand to strengthen every layer of performance from catalog readiness to platform visibility.",
        points: [
          { title: "Catalog Readiness", desc: "Complete product setup and catalog optimization for all quick commerce platforms." },
          { title: "Pricing Optimization", desc: "Dynamic pricing strategy to maximize sales velocity and profitability." },
          { title: "Platform Visibility", desc: "Strategic optimization to ensure your products stand out when customers search." },
          { title: "Conversion Focus", desc: "Every optimization targets actual conversions, not just impressions or clicks." },
        ],
      },
    ],
    link: "/services/quick-commerce",
  },
  {
    id: "programmatic-advertising",
    title: "Programmatic Advertising",
    shortDescription:
      "Deploy media and measurement platforms for a robust media mix that lowers incremental cost of customer acquisition.",
    fullDescription:
      "Programmatic advertising leverages automated technology and data driven strategies to deliver the right message to the right audience at the right time. At Urban Hunter, we use Amazon DSP and other platforms to build full funnel programmatic solutions that maximize efficiency and ROI.\n\nEvery decision is backed by data. We continuously optimize across audience segments, creative formats, and inventory sources to improve efficiency and scale profitably.",
    logo: "/services_ass/programatic_ads.png",
    features: [
      "Amazon DSP — Full funnel programmatic campaigns",
      "Audience segmentation — 1P, 3P & lookalike audiences",
      "Full funnel mapping from impression to conversion",
      "Rich media creatives for better engagement & brand recall",
      "Multi platform approach for lower CPMs",
      "Deep analytics and measurement tools",
      "Brand surveys and right attribution modeling",
    ],
    link: "/services/programmatic-advertising",
  },
];

export const servicesDropdown = [
  {
    title: "Google Ads Management",
    path: "/services/google-ads",
    description: "Turn Search Intent Into Real Revenue",
  },
  {
    title: "Amazon Ads & Marketplace Growth",
    path: "/services/amazon-ads",
    description: "Authorized Amazon Ads Partner",
  },
  {
    title: "Performance Engine",
    path: "/services/performance-engine",
    description: "Google & Meta Ads Campaigns",
  },
  {
    title: "Marketplace Expansion",
    path: "/services/marketplace-expansion",
    description: "Flipkart, Meesho & Nykaa Growth",
  },
  {
    title: "Quick Commerce Acceleration",
    path: "/services/quick-commerce",
    description: "Blinkit, Zepto & Swiggy Instamart",
  },
  {
    title: "Programmatic Advertising",
    path: "/services/programmatic-advertising",
    description: "Full Funnel Media Strategies",
  },
];

export const platformLogos = [
  { name: "Google", image: "/platforms/google.png" },
  { name: "Meta", image: "/platforms/meta.png" },
  { name: "Flipkart", image: "/platforms/flipkart.png" },
  { name: "Meesho", image: "/platforms/mesho.png" },
  { name: "Nykaa", image: "/platforms/nyka.png" },
  { name: "Blinkit", image: "/platforms/blinkit.png" },
  { name: "Zepto", image: "/platforms/zepto.png" },
  { name: "Swiggy Instamart", image: "/platforms/swiggy.png" },
];

export const contactInfo = {
  phone: "+91-99600-37935",
  email: "hello@urbanhunter.in",
  address: "Urban Hunter, India",
  mapLink: "https://maps.google.com",
};

export const footerData = {
  solutions: [
    { name: "Performance Engine", link: "/services/performance-engine" },
    { name: "Marketplace Expansion", link: "/services/marketplace-expansion" },
    { name: "Quick Commerce Acceleration", link: "/services/quick-commerce" },
    { name: "Programmatic Advertising", link: "/services/programmatic-advertising" },
  ],
  whoWeAre: [{ name: "About Us", link: "/about-us" }],
  getInTouch: [
    { name: "Get a Free Growth Audit", link: "/free-audit" },
    { name: "Contact Us", link: "/contact-us" },
  ],
  socials: {
    linkedin: "https://www.linkedin.com/company/urbanhunter/",
    instagram: "https://www.instagram.com/urbanhunter.co.in/",
  },
  copyright: "© 2026 Urban Hunter",
};

export const aboutPageData = {
  title: "About Us",
  // Two separate paragraphs — render each as its own <p> tag in AboutUs.jsx
  descriptionParagraphs: [
    "With over two decades of cumulative marketplace experience, our founding leadership brings deep expertise across global ecommerce ecosystems. From Amazon US and India to Germany, Italy, UK, France, Spain, and broader European markets, we understand how marketplace dynamics evolve across regions and how to adapt strategy accordingly. Today, we manage over $20 million in annual advertising spend, driving more than $200 million in yearly revenue across marketplaces. Our experience spans performance marketing, catalog strategy, competitive positioning, and scalable growth execution built for brands that want structured, long term expansion.",
    "We are a well funded startup backed by experienced founders and industry experts, with strong operational foundations built over the past three years. Our team operates through a structured model where senior marketplace strategists define growth architecture, scaling frameworks, and performance benchmarks, while dedicated account managers execute with discipline, handling optimization, reporting, and daily performance management with precision. This layered approach ensures strategy is implemented consistently and effectively. We don't just manage campaigns we build scalable marketplace growth systems designed for sustainable, profitable expansion.",
  ],
  teamImage: "/platforms/about.jpeg",
  whyChooseUs: [
    {
      title: "Profitability Over Vanity Metrics",
      description:
        "We focus on what truly matters building systems that generate real profit, not just impressive looking numbers. Every campaign is built with sustainable growth as the primary objective.",
    },
    {
      title: "Sustainable Scaling",
      description:
        "We believe in systems over hacks. Our approach ensures that growth is stable, repeatable, and built on a strong foundation not short term spikes that disappear.",
    },
    {
      title: "Intelligence Led Decisions",
      description:
        "We leverage advanced tools including Helium 10, Jungle Scout, Amazon Marketing Cloud, and Drona to uncover opportunities and optimize performance with data backed precision.",
    },
    {
      title: "Founder Led Strategy & Execution",
      description:
        "Every account receives founder level attention and strategic depth. We bring expertise across global markets with a deep understanding of competitive marketplace dynamics.",
    },
  ],
  partnerships: [
    { name: "Amazon Ads Partner", image: "platforms/amazon_ads.png" },
  ],
};

export const contactPageData = {
  title: "Contact Us",
  heading: "Ready to scale with precision? Let's talk.",
  description:
    "Whether you're looking to fix underperforming campaigns or build a new growth engine from scratch, we're here to help. Reach out and let's explore how Urban Hunter can drive real results for your brand.",
  phone: "+91-99600-37935",
  email: "hello@urbanhunter.in",
  address: "Urban Hunter, India",
  mapLink: "https://maps.google.com",
};
